/*
 * Ryan O'Dowd
 * 2025-05-26
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import useTypedSelector from './useTypedSelector';

export default function useGetWrinklesForVerseApiId(verseApiId, translationId) { // @TODO: abstract Passage and PassageDisplay (translation_id different) these component should use this hook
  return useTypedSelector((state) => {
    if (!verseApiId) {
      return [];
    }

    let wrinkles = (state.wrinkles[verseApiId] || []).filter((w) => {
      return w.level_number >= 1;
    });
    if (translationId) {
      // make sure given translation shows up first if present
      wrinkles = wrinkles.sort((w1, w2) => {
        if (translationId === w1.translation_id) {
          return 1;
        }
        if (translationId === w2.translation_id) {
          return -1;
        }

        return w1.translation_id - w2.translation_id;
      });
    }

    return wrinkles;
  }, (oldValue, newValue) => JSON.stringify(oldValue) === JSON.stringify(newValue));
}
